import { Stepper, StepperStep } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { StepperHeader } from "../../shared/ui/StepperHeader";

export type CreateCompanyStepKey = "masterData" | "addresses" | "tags";

interface CompanyStep extends StepperStep {
	key: CreateCompanyStepKey;
}

interface Props {
	activeStep: CreateCompanyStepKey;
}

export const CreateCompanyStepper: FC<Props> = ({ activeStep }) => {
	const { t } = useTranslation();
	const steps: CompanyStep[] = [
		{ label: t("Master data"), optional: false, key: "masterData" },
		{ label: t("Addresses"), optional: true, key: "addresses" },
		{ label: t("Tags"), optional: true, key: "tags" },
	];
	const activeIndex = steps.findIndex((s) => s.key === activeStep);

	return (
		<StepperHeader>
			<Stepper currentStepIndex={activeIndex} steps={steps} />
		</StepperHeader>
	);
};
